import React from "react";

const Select = ({
  name,
  label,
  placeholder,
  value,
  allOptions,
  favourites,
  onChange,
  ...rest
}) => {
  const listKey = "ID";
  const listName = "DESCRIPTION";
  return (
    <div className="form-group">
      {label && <label htmlFor={name}>{label}</label>}
      <select
        className="form-control"
        value={value}
        onChange={onChange}
        name={name}
        id={name}
        {...rest}
      >
        <option disabled value="">
          {placeholder}
        </option>
        <optgroup label="Favourites">
          {favourites.map((option) => (
            <option key={option[listKey]} value={option[listKey]}>
              {option[listName]}
            </option>
          ))}
        </optgroup>
        <optgroup label="All Screens">
          {allOptions.map((option) => (
            <option key={option[listKey]} value={option[listKey]}>
              {option[listName]}
            </option>
          ))}
        </optgroup>
      </select>
    </div>
  );
};

export default Select;
